import styled from '@emotion/styled';
import {Box, Button} from '@mui/material';
import {FC, useContext, useEffect, useState} from 'react';
import Spreadsheet, {CellBase, Matrix} from 'react-spreadsheet';
import * as XLSX from 'xlsx';
import {EventBusContext} from '../../../providers/EventBus';
import {downloadBlob} from '../../../shared/helpers/resolveAndDownloadBlob';

const SheetContainer = styled('div')({
  pointerEvents: 'none',
  userSelect: 'none',
  height: '100%',
  '& .Spreadsheet': {
    height: '100%',
  },
  '& .Spreadsheet__cell': {
    outline: 'none !important',
    cursor: 'default',
  },
});

export const ReportPreview: FC = () => {
  const {bus} = useContext(EventBusContext);
  const [fileData, setFileData] = useState<Matrix<CellBase>>([]);

  const getFileNameForBlob = () => {
    const queryParams = new URLSearchParams(window.location.search);
    return queryParams.get('data') ?? '';
  };

  const getUrlForBlob = () => {
    const {pathname, origin} = window.location;
    const id = pathname.split('/').pop();
    return `blob:${origin}/${id}`;
  };

  const downloadReport = async () => {
    downloadBlob(getUrlForBlob(), getFileNameForBlob());
  };

  const getBlobFromObjectURL = async (objectURL: string) => {
    const response = await fetch(objectURL);
    return await response.blob();
  };

  const fetchExcelFile = async (blob: Blob) => {
    try {
      const reader = new FileReader();
      reader.onload = (e) => {
        if (!e.target?.result || typeof e.target?.result === 'string') return;
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, {type: 'array'});
        const sheet = workbook.Sheets[workbook.SheetNames[0]];
        const jsonData = XLSX.utils.sheet_to_json<string[]>(sheet, {
          header: 1,
        });

        const formattedData = jsonData.map((row) => row.map((cell) => ({value: cell?.toString() || ''})));

        setFileData(formattedData);
      };

      reader.readAsArrayBuffer(blob);
    } catch (error) {
      bus?.emit('error', [error]);
    }
  };

  const init = async () => {
    const url = getUrlForBlob();
    const blob = await getBlobFromObjectURL(url);
    fetchExcelFile(blob);
  };

  useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box
      sx={{
        p: 4,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        height: '100dvh',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          gap: 2,
        }}
      >
        <Button variant="outlined" onClick={downloadReport}>
          Скачать отчет
        </Button>
        <Button variant="outlined" onClick={window.close}>
          Закрыть
        </Button>
      </Box>

      <Box
        sx={{
          overflow: 'auto',
          height: '100%',
          py: 2,
        }}
      >
        <SheetContainer>
          <Spreadsheet data={fileData} />
        </SheetContainer>
      </Box>
    </Box>
  );
};
